import * as NUMBER from 'constant/number'
import * as MENU_ACTION from 'constant/action/menu'
import { handleActions } from 'redux-actions'

const initialState = {
  mobile: window.innerWidth < NUMBER.MOBILE,
  open: window.innerWidth > NUMBER.MOBILE
}

export default handleActions(
  {
    [MENU_ACTION.OPEN]: (state, action) => ({
      ...state,
      open: true
    }),
    [MENU_ACTION.CLOSE]: (state, action) => ({
      ...state,
      open: false
    }),
    [MENU_ACTION.MOBILE]: (state, action) => ({
      ...state,
      mobile: action.payload
    })
  },
  initialState
)
